import Vue from 'vue'
import Router from 'vue-router'
import Meetups from '@/components/Meetup/Meetups'
import CreateMeetup from '@/components/Meetup/CreateMeetup'
import Profile from '@/components/User/Profile'
import Signup from '@/components/User/Signup'
import NotFound from '@/components/NotFound'
import SigninLpj4WQxzG0qu9vUB3 from '@/components/User/SigninLpj4WQxzG0qu9vUB3'
import Meetup from '@/components/Meetup/Meetup'
import Votauth from '@/components/Meetup/Votauth'
import AuthGuard from './auth-guard'


const routes = [
    {
      path: '/',
      name: 'Meetups',
      component: Meetups
    },
    {
      path: '/list/:id',
      name: 'Meetup',
      props: true,
      component: Meetup,
      meta: { hideHeader: true  }
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    }, {
      path: '*',
      redirect: '/404'
    }
]

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes
})



// WEBPACK FOOTER //
// ./src/router/index.js